"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const type_graphql_1 = require("type-graphql");
const typeorm_1 = require("typeorm");
const OsmosysBaseEntity_1 = require("../OsmosysBaseEntity");
const auth_1 = require("../auth");
const OsmosysResourceInstance_1 = require("./OsmosysResourceInstance");
const OsmosysResourceVersion_1 = require("./OsmosysResourceVersion");
/*
    An OsmosysResource could be:
      - a Version of Master OsmosysResource
      - an Instance of Master OsmosysResource
*/
let OsmosysResource = class OsmosysResource extends OsmosysBaseEntity_1.OsmosysBaseEntity {
};
tslib_1.__decorate([
    type_graphql_1.Field(() => auth_1.User, { nullable: false }),
    typeorm_1.ManyToOne(() => auth_1.User, {
        cascade: true,
    }),
    tslib_1.__metadata("design:type", Object)
], OsmosysResource.prototype, "creatingUser", void 0);
tslib_1.__decorate([
    typeorm_1.RelationId((resource) => resource.creatingUser),
    tslib_1.__metadata("design:type", Number)
], OsmosysResource.prototype, "creatingUserId", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => auth_1.Workspace, { nullable: false }),
    typeorm_1.ManyToOne(() => auth_1.Workspace, {
        cascade: true,
    }),
    tslib_1.__metadata("design:type", Object)
], OsmosysResource.prototype, "workspace", void 0);
tslib_1.__decorate([
    typeorm_1.RelationId((resource) => resource.workspace),
    tslib_1.__metadata("design:type", Number)
], OsmosysResource.prototype, "workspaceId", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => auth_1.Organization, { nullable: true }),
    typeorm_1.ManyToOne(() => auth_1.Organization, {
        cascade: true,
        nullable: true,
    }),
    tslib_1.__metadata("design:type", Object)
], OsmosysResource.prototype, "organization", void 0);
tslib_1.__decorate([
    typeorm_1.RelationId((resource) => resource.organization),
    tslib_1.__metadata("design:type", Number)
], OsmosysResource.prototype, "organizationId", void 0);
tslib_1.__decorate([
    type_graphql_1.Field({ nullable: false }),
    typeorm_1.Column(),
    tslib_1.__metadata("design:type", String)
], OsmosysResource.prototype, "name", void 0);
tslib_1.__decorate([
    type_graphql_1.Field({ nullable: false }),
    typeorm_1.Column(),
    tslib_1.__metadata("design:type", String)
], OsmosysResource.prototype, "slug", void 0);
tslib_1.__decorate([
    type_graphql_1.Field({ nullable: false }),
    typeorm_1.Column({ nullable: false }),
    tslib_1.__metadata("design:type", String)
], OsmosysResource.prototype, "resourceType", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({ default: false }),
    tslib_1.__metadata("design:type", Boolean)
], OsmosysResource.prototype, "isMaster", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => [OsmosysResourceVersion_1.OsmosysResourceVersion]),
    typeorm_1.OneToMany(() => OsmosysResourceVersion_1.OsmosysResourceVersion, version => version.resource, {
        cascade: true,
    }),
    tslib_1.__metadata("design:type", Object)
], OsmosysResource.prototype, "versions", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => OsmosysResourceVersion_1.OsmosysResourceVersion, { nullable: true }),
    typeorm_1.OneToOne(() => OsmosysResourceVersion_1.OsmosysResourceVersion, version => version.resource, { cascade: true, nullable: true }),
    typeorm_1.JoinColumn(),
    tslib_1.__metadata("design:type", Object)
], OsmosysResource.prototype, "version", void 0);
tslib_1.__decorate([
    typeorm_1.RelationId((resource) => resource.version),
    tslib_1.__metadata("design:type", Number)
], OsmosysResource.prototype, "versionId", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => [OsmosysResourceInstance_1.OsmosysResourceInstance]),
    typeorm_1.OneToMany(() => OsmosysResourceInstance_1.OsmosysResourceInstance, instance => instance.masterResource, { cascade: true }),
    tslib_1.__metadata("design:type", Object)
], OsmosysResource.prototype, "instances", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => OsmosysResourceInstance_1.OsmosysResourceInstance, { nullable: true }),
    typeorm_1.OneToOne(() => OsmosysResourceInstance_1.OsmosysResourceInstance, instance => instance.instanceResource, { cascade: true, nullable: true }),
    typeorm_1.JoinColumn(),
    tslib_1.__metadata("design:type", Object)
], OsmosysResource.prototype, "instance", void 0);
tslib_1.__decorate([
    typeorm_1.RelationId((resource) => resource.instance),
    tslib_1.__metadata("design:type", Number)
], OsmosysResource.prototype, "instanceId", void 0);
OsmosysResource = tslib_1.__decorate([
    type_graphql_1.ObjectType(),
    typeorm_1.Entity(),
    typeorm_1.Unique('UQ_NAME', ['workspace', 'resourceType', 'name']),
    typeorm_1.Unique('UQ_SLUG', ['workspace', 'resourceType', 'slug'])
], OsmosysResource);
exports.OsmosysResource = OsmosysResource;
//# sourceMappingURL=OsmosysResource.js.map